import { OptionChips, type ChipOption } from '../../components/OptionChips';
import { useTheme } from '../../components/useTheme';
import type { ThemePreference } from '../../lib/theme';

const THEME_OPTIONS: readonly ChipOption[] = [
  { value: 'system', label: 'System', title: 'Follow this device’s light or dark setting' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

function isThemePreference(value: string): value is ThemePreference {
  return value === 'system' || value === 'light' || value === 'dark';
}

/**
 * Light or dark. Stored on this device, not the account, so it applies from
 * the sign-in screen onwards and two machines can differ.
 */
export function AppearanceCard() {
  const { preference, theme, setPreference } = useTheme();

  return (
    <section className="wizard settings-card">
      <div className="settings-card__head">
        <h2 className="wizard__title">Appearance</h2>
        <p className="settings-card__lede">
          Saved on this device only. Posts and previews look the same in either theme.
        </p>
      </div>

      <OptionChips
        legend="Theme"
        hint={preference === 'system' ? `Following this device: ${theme} now.` : undefined}
        mode="single"
        name="theme"
        options={THEME_OPTIONS}
        selected={[preference]}
        onToggle={(value) => {
          if (isThemePreference(value)) setPreference(value);
        }}
      />
    </section>
  );
}
